import React from "react";
import "./BllueCardHeader.css";
import usdepLOGO from "./usdepLOGO.png";
const LocomotiveHeader = () => {
  return (
    <div className="BC_header">
      <div className="BC_ROW1">
        <div>
          <img src={usdepLOGO} alt="DOT Logo" style={{ width: "50px" }} />
        </div>
        <div className="LIRR">Locomotive Inspection and Repair Record</div>
      </div>
      <div className="BC_ROW2">
        <div style={{ lineHeight: "1.2", fontFamily: "auto", marginBlockStart: "10px", fontWeight: "700" }}>
          <div>U.S. Department of Transportation</div>
          <div>Federal Railroad Administration</div>
        </div>
        <div className="OMBstyles">OMB No. 2130-0004</div>
      </div>
    </div>
  );
};

export default LocomotiveHeader;



// WEBPACK FOOTER //
// ./src/components/BlueCardReport/BlueCardReportView/BlueCardHeader/BllueCardHeader.jsx